module.exports = __webpack_public_path__ + "static/media/resume.6c5f1757.pdf";